import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-white border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-3">
              <div className="w-8 h-8 bg-teal-600 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-sm">RD</span>
              </div>
              <span className="font-semibold text-gray-900">
                Radiology Dashboard
              </span>
            </div>
            <p className="text-sm text-gray-500 max-w-xs">
              AI-powered radiology reporting. Built by Axiom Data.
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-sm font-semibold text-gray-900 mb-3">
              Product
            </h4>
            <ul className="space-y-2">
              <li>
                <a
                  href="#features"
                  className="text-sm text-gray-500 hover:text-teal-600 transition-colors"
                >
                  Features
                </a>
              </li>
              <li>
                <a
                  href="#pricing"
                  className="text-sm text-gray-500 hover:text-teal-600 transition-colors"
                >
                  Pricing
                </a>
              </li>
              <li>
                <Link
                  to="/login"
                  className="text-sm text-gray-500 hover:text-teal-600 transition-colors"
                >
                  Login
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold text-gray-900 mb-3">
              Contact
            </h4>
            <ul className="space-y-2">
              <li>
                <a
                  href="mailto:info@axiomdata.com.au"
                  className="text-sm text-gray-500 hover:text-teal-600 transition-colors"
                >
                  info@axiomdata.com.au
                </a>
              </li>
              <li>
                <a
                  href="https://axiomdata.com.au"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-gray-500 hover:text-teal-600 transition-colors"
                >
                  axiomdata.com.au
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-gray-100 text-center">
          <p className="text-sm text-gray-400">
            &copy; {new Date().getFullYear()} Axiom Data. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
